class Header{
    constructor() {
        this.header = document.querySelector('.header');

        this.hamburger = this.header.querySelector('.header__hamburger');
        this.nav_children = this.header.querySelector('.menu-item-has-children') ? this.header.querySelectorAll('.menu-item-has-children') : null;

        if (this.header.classList.contains('header--scroll')){
            window.addEventListener('scroll', () => {
                let scrollHeight = window.scrollY;
                if (window.scrollY > 0){
                    this.header.classList.remove('header--black');
                }else{
                    this.header.classList.add('header--black');
                }
            });
        }

        this.hamburger.addEventListener('click', e => this.header.classList.toggle('active'));
        if (window.innerWidth < 991) {
            !this.nav_children || this.nav_children.forEach(el => el.addEventListener('click', e => {
               // e.preventDefault();
                el.classList.toggle('active');
            }));
        }
   
    }
}


export default Header;